import { forwardRef, useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useMedia } from 'react-use';
import styled from 'styled-components';

import {
  IS_PAY_ANYONE_P2P,
  IS_REFERRAL_SPECIFIC_ENROLLMENT,
} from 'consts/appConsts';

import useRoutes from 'hooks/useRoutes';

import { selectEnrollmentRequireEmailVerification } from 'selectors/enrollment';

import { screenSizes } from 'theme/screenSizes';

const StepHeader = forwardRef(function ({ children }, ref) {
  const isTablet = useMedia(`(max-width: ${screenSizes.tablet}px)`);
  const { userProgressIndex } = useRoutes();
  const headerRef = useRef(ref);
  const emailVerification = useSelector(
    selectEnrollmentRequireEmailVerification
  );

  useEffect(() => {
    if (!isTablet || IS_PAY_ANYONE_P2P || IS_REFERRAL_SPECIFIC_ENROLLMENT) {
      window?.scrollTo(0, 0);
    } else if (isTablet && (userProgressIndex > 1 || emailVerification)) {
      // For every page past first time the user sees the account page, scroll
      _scrollTo(headerRef?.current);
    }
  }, [userProgressIndex, isTablet, emailVerification]);

  /**
   * Reset scroll to header when users progress to next step
   */
  function _scrollTo(scrollToElement) {
    if (scrollToElement && scrollToElement.scrollIntoView) {
      scrollToElement.scrollIntoView();
    }
  }

  return <Header ref={headerRef}>{children}</Header>;
});

StepHeader.displayName = 'StepHeader';

StepHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StepHeader;

const Header = styled.header`
  margin: 0;
`;
